import { render } from "./MessageTableBuy.vue?vue&type=template&id=baf2bffa"
import script from "./MessageTableBuy.vue?vue&type=script&lang=js"
export * from "./MessageTableBuy.vue?vue&type=script&lang=js"

import "./MessageTableBuy.vue?vue&type=style&index=0&id=baf2bffa&lang=scss"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__